import { useContext } from 'react';
import { FlashcardContext } from '../flashcard-provider';

export function useFlashcardContext() {
  const ctx = useContext(FlashcardContext);

  if (!ctx) {
    throw new Error('Unknown FlashcardContext');
  }

  return ctx;
}
